export default __webpack_public_path__ + "static/gearsOfWar-full-15e1eed8431fe44d95ab855aaa789d5f.svg";